import styled from 'styled-components';
export const Container = styled.div`
  /* border-bottom: 1px solid #efefef; */
  padding: 20px 0;
`;
